import type * as React from 'react'
import { BatchTask } from './BatchTask'
import { Provider } from './store'
import { TaskType } from './TaskType'

export type TasksProviderProps = React.PropsWithChildren<object>

export function TasksProvider({ children }: TasksProviderProps) {
	return (
		<Provider>
			<TaskType name="batch" element={BatchTask} />
			{children}
		</Provider>
	)
}
